 
import styled from 'styled-components';
import theme from 'common/theme';

export const CalendarButtonContainer = styled.button.attrs(({as}:{as?: string}) => ({
  as: as || 'button'
}))<{full?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  font-family: inherit;
  font-weight: inherit;
  cursor: pointer;
  text-align: left;
  transition: color 300ms ease;
  gap: .5em;
  padding: .8em 1em;
  border: none;
 
  box-shadow: ${theme.effects.boxShadow.main};
  max-width: max-content;

  &.full-width {
    max-width: initial;
  }

  background-color: ${theme.colors.neg};
  color: ${theme.colors.main};
  border-radius: ${theme.radius.base};

  &:hover {
    color: ${theme.colors.jbtBlue};
  }

  .date-col {
    padding: 0.5em 0 0.3em 0;

    &.pad-l {
      margin-left: 5px;
    }

    .date-col__label {
      font-weight: 300;
      font-size: 0.8em;
      opacity: 0.7;
    }
  }

  .icon-calendar {
    transform: translateY(-0.09em);
  }

  .calendar-v2-button--dropdown {
    position: abosulte;
  }
`;
